import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";
import { connect } from "react-redux";

function ProductListingProduct(props) {

  const [form, setForm] = useState(
    props.listingData && props.listingData.formData || {}
  );

  //restore on back
  useEffect(() => {
    if (props.listingData && props.listingData.formData) {
      setForm(props.listingData.formData);
    }
  }, [props.listingData]);

  //handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  //next step
  const handleNext = () => {
    props.setListingData(prev => ({
      ...prev,
      formData: form
    }));

    props.nextStep();
  };

  return (
    <Container>
      <Row>

        <Col md={12} className="mt-2 mb-2">
          <h4>Step 2 : Product Identification</h4>
        </Col>

        <Col md={12}>
          <Card className="p-4">

            {/* Product Name */}
            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Product Name :</Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="productTitle"
                  value={form.productTitle || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            {/* Brand */}
            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Brand :</Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="brand"
                  value={form.brand || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            {/* GTIN */}
            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">UPC / EAN / GTIN :</Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="gtin"
                  value={form.gtin || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            {/* SKU */}
            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">SKU :</Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="sku"
                  value={form.sku || ""}
                  onChange={handleChange}
                />
              </Col>
            </Row>

          </Card>
        </Col>

        {/* Navigation */}
        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button className="btn btn-light" onClick={props.prevStep}>
            ← Back
          </button>

          <button className="btn btn-primary" onClick={handleNext}>
            Next →
          </button>
        </Col>

      </Row>
    </Container>
  );
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
  accessLevel: state.loggedUser.accessLevel,
  status: state.loggedUser.status,
});

export default connect(mapStateToProps)(ProductListingProduct);